import basePath from './basePath';
import axios from 'axios';
import { v4 as uuid } from 'uuid';
import { reqLog, resLog } from 'logger';
import queryString from 'query-string';

const instance1 = axios.create({
    baseURL: basePath.FRONT_END_HOST,
    withCredentials: true,
    crossDomain: true
});

const upload_instance = axios.create({
    baseURL: basePath.UPLOAD_HOST,
    withCredentials: true,
    crossDomain: true
});

const lead_ingestion_instance = axios.create({
    baseURL: basePath.LEAD_INGEST_HOST,
    withCredentials: true,
    crossDomain: true
});

const parsed = queryString.parse(window.location.search);

if (!parsed.feature) {
    const parts = window.location.hostname.split('.');
    if (parts.length > 3) {
        parsed.feature = parts[0];
    }
}

if (parsed.feature) {
    console.log("FEATURE", parsed.feature);
    if (!parsed.hosts) {
        parsed.hosts = 'app';
    }
    if (parsed.hosts.includes('upload')) {
        upload_instance.defaults.baseURL = basePath.UPLOAD_HOST.substr(0, 8) + parsed.feature + '-' + basePath.UPLOAD_HOST.substr(8);
    }
}

instance1.interceptors.request.use(async (config) => {
    let requestID = uuid();
    config.headers['X-Request-ID'] = requestID;
    reqLog.append({
        request_id: requestID,
        url: config.url,
        method: config.method,
        headers: config.headers,
    })
    return config;
}, (error) => {
    return Promise.reject(error);
});

instance1.interceptors.response.use( async (response)=> {
    let requestID = response.hasOwnProperty("data")? response.data.requestID : null;
    resLog.append({
        request_id: requestID,
        status: response.status,
        body: response.data,
    })
    return response;
})

upload_instance.interceptors.request.use(async (config) => {
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default {
    instance1,
    upload_instance,
    lead_ingestion_instance
};
